import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import ScrollToTopButton from "./ScrollToTopButton";


const ServicesPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [activeTab, setActiveTab] = useState("eye");
  const [bgPosition, setBgPosition] = useState(0);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  // Background images for parallax effect
  const backgroundImages = [
   " images/banner1.jpg",
 "images/banner2.jpg", 
 "images/banner3.avif", 
 "images/banner4.avif",

  ];

  useEffect(() => {
    // Trigger animations when component mounts
    const loadTimer = setTimeout(() => {
      setIsLoaded(true);
    }, 300);
    
    // Sliding background animation
    const interval = setInterval(() => {
      setBgPosition(prev => (prev + 1) % backgroundImages.length);
    }, 7000);
    
    // Mouse movement handling for parallax
    const handleMouseMove = (e) => {
      const x = (e.clientX - window.innerWidth / 2) / 25;
      const y = (e.clientY - window.innerHeight / 2) / 25;
      setMousePosition({ x, y });
    };
    
    document.addEventListener('mousemove', handleMouseMove);
    
    return () => {
      clearTimeout(loadTimer);
      clearInterval(interval);
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  // Switch between service tabs
  const switchTab = (tab) => {
    setActiveTab(tab);
  };

  // Service data based on active tab
  const services = {
    eye: [
      {
        id: 1,
        title: " Phacoemulsification (Phaco Surgery)",
        description: "Phacoemulsification, commonly known as Phaco Surgery, is a modern cataract removal technique. It is a painless, stitchless, and highly advanced procedure that uses topical anesthesia—meaning no injection is required. The surgery does not require an eye patch and allows for a quicker recovery. A foldable intraocular lens (IOL) is implanted through a small incision, enabling faster healing and better visual outcomes. It is considered one of the safest and most effective methods for treating cataracts today.",
        image: "/eye/eye15.webp",
      },

      {
        id: 2,
        title: "Cataract",
        description: "A cataract is an eye condition characterized by the clouding of the natural lens in the eye, leading to vision loss. Naturally, the eye's lens is clear and allows light to pass through, focusing on the retina at the back of the eye. but when a cataract develops, the lens becomes cloudy and interferes with the normal passage of light.",
        image: "/eye/eye1.png",
      },
      {
        id: 3,
        title: "Diabetic Retinopathy",
        description: "Diabetic retinopathy is an eye condition, it is caused by diabetes that occurs due to damage to the blood vessels in the retina, the light-sensitive tissue at the back of the eye. When diabetes is not well managed, it can lead to high levels of blood sugar, which in turn can cause damage to blood vessels throughout the body including those in the retina.",
        image: "/eye/eye2.png",
      },
      {
        id: 4,
        title: "Cornea and Associated Diseases",
        description: "The cornea is the transparent front part of the eye that covers the iris, pupil, and anterior parts of an eye. The cornea is composed of specialized cells and proteins and lacks blood vessels to maintain transparency. The conditions that affect the cornea are called corneal diseases.",
        image: "/eye/eye3.png",
      },
      {
        id: 5,
        title: "Glaucoma Treatment",
        description: "Glaucoma is an eye condition that directly damages the optic nerve (the bundle of nerve fibers that carries information from the eye to the brain). This damage is often caused by an increased pressure in the eye, known as intraocular pressure (IOP). The optic nerve is crucial for vision, and if it becomes damaged, it can lead to vision loss and blindness.",
        image: "/eye/eye4.png",
      },
      {
        id: 6,
        title: "Neuro-Ophthalmology",
        description: "Neuro ophthalmology is a combination of super specialty of both neurology and ophthalmology. This field deals with the complicated conditions or diseases between the brain and eyes that affect eye movement, vision, alignment, and pupillary reflexes.",
        image: "/eye/eye5.webp",
      },
      {
        id: 7,
        title: "Oculoplasty",
        description: "Oculoplasty, also known as oculoplastic surgery is a specialized branch of ophthalmology that focuses on the disease diagnosis, affecting the structures around the eyes, including the eyelids, tear ducts, orbit (eye socket), and the surrounding facial tissues. The term oculoplasty is derived from the combination of oculo (related to the eye) and plasty (surgery or reconstruction).",
        image: "/eye/eye6.png",
      },
      {
        id: 8,
        title: "Pediatric Ophthalmology",
        description: "Pediatric ophthalmology is a subspecialty of ophthalmology, that focuses on children's eye health. It involves diagnosing and treating eye problems in infants, children, and adolescents.",
        image: "/eye/eye7.png",
      },
      {
        id: 9,
        title: "Refractive Surgeries",
        description: "Refractive surgeries are a group of surgical procedures designed to improve or correct vision by reshaping the cornea or, in some cases, by using an intraocular lens. These surgeries are typically performed to address common vision problems such as near-sightedness (myopia), farsightedness (hyperopia), and astigmatism.",
        image: "/eye/eye8.png",
      },
      {
        id: 10,
        title: "Retina and Associated Diseases",
        description: "The retina is a thin layer of tissue at the back of the eye that plays a crucial role in vision. It contains cells,  sensitive to light and is responsible for converting light signals into electrical impulses and sent to the brain through the optic nerve. Various disorders can affect the retina, leading to vision problems.",
        image: "/eye/eye9.png",
      },
      {
        id: 11,
        title: " LASIK Surgery",
        description: "LASIK (Laser-Assisted In Situ Keratomileusis) or laser eye treatment is a popular laser eye surgery technique that is used to correct conditions related to vision such as myopia (nearsightedness), hyperopia (farsightedness), and astigmatism. Lasik laser eye surgery aims to clear the front part of the eye, reshape the cornea, and improve how the eye focuses light onto the retina.",
        image: "/eye/eye10.png",
      },
     
      {
        id: 12,
        title: "ICL Eye Surgery",
        description: "ICL or Implantable Collamer Lens surgery is a type of refractive surgery, in which an artificial lens is implanted in the eyes permanently. ICL is required to treat moderate to severe Nearsightedness (Myopia), Farsightedness (Hyperopia), and Astigmatism. This surgery may be possible for people who don’t meet the criteria for LASIK surgery.",
        image: "/eye/eye12.png",
      },
      {
        id: 13,
        title: "Photorefractive Keratectomy",
        description: "Photorefractive keratectomy is a type of laser eye surgery, that is used to treat refractive errors, Nearsightedness (myopia), Farsightedness (hyperopia), and Astigmatism) with an excimer laser (A computer-generated, cold laser beam), used to remove and sculpt corneal tissue at the microscopic level. This treatment aims to reduce an individual's dependency on glasses and contact lenses.",
        image: "/eye/eye13.png",
      },
      {
        id: 14,
        title: "Squint Eye",
        description: "Squint eye or strabismus is one of the neurological visual disorders whereby the normal neurologic balance between the muscles controlling eye movement is disrupted, leading to misaligned eyes that cannot point at a common point simultaneously. One eye may look directly ahead as the other eye turns inward, outward, upward, or even downward. This misalignment could occur all the time or only some of the time.",
        image: "/eye/eye14.jpg",
      },
     
    ],
    ortho: [
      {
          id: 1,
          title: "TRAUMA SURGERIES",
          description: "Trauma Surgeries involve the urgent treatment of injuries resulting from accidents, falls, or other high-impact incidents. These surgeries are performed to repair broken bones, damaged tissues, and restore normal function to the injured area. With expert surgical intervention and timely care, trauma surgery aims to stabilize the patient, prevent complications, and promote fast recovery. Our team ensures personalized care for every critical case.",
          image: "./ortho/ortho5.jpg",
        },

        {
            id: 2,
            title: "KNEE REPLACEMENT",
            description: "Knee Replacement surgery is performed to relieve pain and restore function in severely diseased knee joints. It involves replacing the damaged parts of the knee with artificial implants that mimic natural movement. This procedure is ideal for patients suffering from chronic arthritis or injury-related joint damage. With modern techniques, recovery is quicker, and patients can return to an active lifestyle with improved mobility and comfort.",
            image: "./ortho/ortho6.webp",
          },
          {
              id: 3,
              title: "HIP REPLACEMENT",
              description: "Hip Replacement surgery is a highly effective procedure for relieving hip pain caused by arthritis, injury, or wear-and-tear. In this surgery, the damaged bone and cartilage are replaced with artificial components to restore joint function. It helps improve mobility, reduce discomfort, and enhance the quality of life. With advanced surgical techniques and personalized rehabilitation, patients can regain strength and return to their normal activities smoothly and safely.",
              image: "./ortho/ortho4.webp",
            },

            {
                id: 4,
                title: "SHOULDER SURGERIES",
                description: "Shoulder Surgeries are performed to treat conditions like rotator cuff tears, dislocations, frozen shoulder, and arthritis. These procedures aim to relieve pain, restore strength, and improve the shoulder’s range of motion. Depending on the severity, surgeries may range from arthroscopic (minimally invasive) techniques to full joint replacements. Our experienced orthopedic team uses the latest surgical advancements to ensure optimal recovery and long-term shoulder health, helping patients return to daily activities with ease.",
                image: "./ortho/ortho3.webp",
              },
              {
                  id: 5,
                  title: "SPINE SURGERIES",
                  description: "Spine Surgery involves procedures aimed at relieving pain and restoring function in patients with spinal disorders. It can treat conditions like herniated discs, spinal stenosis, scoliosis, and degenerative disc disease. With advanced techniques like minimally invasive surgery, patients experience faster recovery, reduced pain, and minimal scarring. Spine surgery not only improves mobility but also enhances the quality of life. At our clinic, we offer expert care using state-of-the-art technology to ensure safe and effective outcomes.",
                  image: "./ortho/ortho1.webp",
                },
                {
                    id: 6,
                    title: "FOOT & ANKLE SURGERIES",
                    description: "Foot & Ankle Surgeries are specialized procedures designed to treat a wide range of conditions such as fractures, ligament injuries, bunions, flat feet, and arthritis. These surgeries help restore mobility, reduce chronic pain, and improve overall foot alignment and function. Whether it’s a minimally invasive procedure or complex reconstruction, our expert orthopedic team ensures precision and personalized care. With advanced surgical techniques and tailored rehabilitation plans, we aim for faster recovery and long-term relief for every patient.",
                    image:  "./ortho/ortho2.webp",
                  },

                  {
                      id: 7,
                      title: "PEDIATRIC ORTH. SURGERIES",
                      description: "Pediatric Orthopedic Surgeries focus on treating musculoskeletal issues in infants, children, and adolescents. These surgeries address conditions like congenital deformities, limb length discrepancies, fractures, and growth plate injuries. Children's bones and joints are still developing, so treatments are tailored to support healthy growth. Minimally invasive techniques and advanced imaging help ensure accurate diagnosis and effective outcomes. Early intervention can prevent complications and promote normal development. Pediatric orthopedic care is designed with gentle, child-friendly approaches for quicker recovery and long-term well-being.",
                      image:  "./ortho/ortho7.webp",
                    },
                    {
                        id: 8,
                        title: "ARTHROSCOPIES SURGERY",
                        description: "Arthroscopic Surgery is a minimally invasive procedure used to diagnose and treat joint problems. It involves inserting a small camera (arthroscope) into the joint through a tiny incision, allowing the surgeon to view the inside on a screen. Commonly performed on the knee, shoulder, elbow, or ankle, it helps repair torn ligaments, remove damaged cartilage, or treat inflammation. This technique causes less tissue damage, leading to reduced pain, minimal scarring, and faster recovery. Arthroscopy is often a day-care procedure, enabling patients to return to normal activities sooner. It's a safe and effective method for managing joint-related issues.",
                        image:  "./ortho/ortho8.webp",
                      },
  
    ]
  };

  // Animation variants for framer-motion
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const cardVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: { 
      y: 0, 
      opacity: 1,
      transition: { 
        type: "spring", 
        stiffness: 100,
        damping: 12
      }
    },
    hover: { 
      y: -10,
      boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
      transition: { type: "spring", stiffness: 300, damping: 15 }
    }
  };

  const imageVariants = {
    hover: { 
      scale: 1.1,
      rotate: 5,
      transition: { type: "spring", stiffness: 300, damping: 10 }
    }
  };

  return (
    <div className="relative min-h-screen bg-gray-50 overflow-hidden mt-[36px]">
      {/* Background elements */}
      <div className="absolute inset-0 bg-white/50 z-0">         
        <div className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M25 0v15h15v10H25v15H15V25H0V15h15V0h10z' fill='%2322c55e' fill-opacity='0.2'/%3E%3C/svg%3E\")",
            backgroundSize: "30px 30px"
          }}
        ></div>
      </div>
      
      {/* Sliding background images with parallax effect */}
      <div className="absolute inset-0 z-0">
        {backgroundImages.map((img, index) => (
          <motion.div 
            key={index}
            className="absolute inset-0 w-full h-full bg-cover bg-center"
            initial={{ opacity: 0, scale: 1 }}
            animate={{ 
              opacity: bgPosition === index ? 0.5 : 0,
              scale: bgPosition === index ? 1.05 : 1,
              x: bgPosition === index ? mousePosition.x : 0,
              y: bgPosition === index ? mousePosition.y : 0,
            }}
            transition={{ duration: 1.5, ease: "easeInOut" }}
            style={{ backgroundImage: `url(${img})` }}
          ></motion.div>
        ))}
      </div>
      
      {/* Animated floating shapes */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        <motion.div 
          className="shape-circle"
          animate={{
            y: [0, -20, 0],
            rotate: [0, 5, 0]
          }}
          transition={{
            duration: 8,
            ease: "easeInOut",
            times: [0, 0.5, 1],
            repeat: Infinity
          }}
        ></motion.div>
        <motion.div 
          className="shape-square"
          animate={{
            y: [0, 20, 0],
            rotate: [45, 55, 45]
          }}
          transition={{
            duration: 12,
            ease: "easeInOut",
            times: [0, 0.5, 1],
            repeat: Infinity
          }}
        ></motion.div>
        <motion.div 
          className="shape-triangle"
          animate={{
            y: [0, -30, 0],
            x: [0, 15, 0],
            rotate: [0, -8, 0]
          }}
          transition={{
            duration: 10,
            ease: "easeInOut",
            times: [0, 0.5, 1],
            repeat: Infinity,
            delay: 2
          }}
        ></motion.div>
      </div>
      
      {/* Header Section */}
      <div className="container mx-auto px-4 py-16 md:py-20 lg:py-24 relative z-10">
        {/* Page Title */}
        <motion.div 
          className="max-w-4xl mx-auto text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <motion.h1
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-800 mb-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Our 
            <motion.span 
              className="bg-gradient-to-r from-blue-600 to-teal-500 bg-clip-text text-transparent px-3"
              animate={{ 
                backgroundPosition: ["0% 50%", "100% 50%", "0% 50%"] 
              }}
              transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
            >
              Services
            </motion.span>
          </motion.h1>
          
          <motion.p
            className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Comprehensive healthcare solutions delivered by our expert team of specialists using cutting-edge technology and compassionate care.
          </motion.p>
        </motion.div>
        
        {/* Service Type Selector */}
        <motion.div 
          className="flex justify-center space-x-4 mb-12"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <motion.button
            className={`px-6 py-3 rounded-full text-lg font-medium transition-all duration-300 ${
              activeTab === "eye" 
                ? "bg-blue-600 text-white shadow-lg" 
                : "bg-white text-blue-600 hover:bg-blue-50"
            }`}
            onClick={() => switchTab("eye")}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Eye Care
          </motion.button>
          <motion.button
            className={`px-6 py-3 rounded-full text-lg font-medium transition-all duration-300 ${
              activeTab === "ortho" 
                ? "bg-teal-600 text-white shadow-lg" 
                : "bg-white text-teal-600 hover:bg-teal-50"
            }`}
            onClick={() => switchTab("ortho")}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Orthopedic Care
          </motion.button>
        </motion.div>



        
        {/* Services Grid */}
        <motion.div 
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          key={activeTab} // This forces re-render of animation when tab changes
        >
          {services[activeTab].map((service) => (
            <motion.div 
              key={service.id}
              className="bg-white rounded-xl shadow-lg overflow-hidden"
              variants={cardVariants}
              whileHover="hover"
            >
             
 <div className={`h-40 bg-${service.color}-100 relative overflow-hidden flex items-center justify-center`}>
    {/* Main image in rectangular shape with minimal or no rounding */}
    <motion.img
      src={service.image}
      alt={service.title}
      className={`w-85 h-45 object-cover border-4 border-${service.color}-200`} 
      // Removed rounded-xl to make it rectangular
      variants={imageVariants}
      whileHover="hover"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
    />
    <div className="absolute inset-0 bg-gradient-to-br from-transparent to-black/10"></div>
    
    {/* Animated particles */}
    <div className="particles-container">
      {[...Array(5)].map((_, i) => (
        <motion.div
          key={i}
          className={`particle bg-${service.color}-500`}
          animate={{
            x: [0, Math.random() * 60 - 30],
            y: [0, Math.random() * -80],
            opacity: [0, 0.8, 0],
            scale: [0, 1, 0.5]
          }}
          transition={{
            duration: 2 + Math.random() * 2,
            repeat: Infinity,
            delay: Math.random() * 2,
            ease: "easeOut"
          }}
        />
      ))}
    </div>
  </div>
  
              <div className="p-6">
                <motion.h3 
                  className={`text-xl font-bold text-gray-800 mb-3 flex items-center text-${service.color}-700`}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                >
                  <motion.div 
  className={`w-12 h-12 rounded-full bg-${service.color}-100 flex items-center justify-center mr-3 overflow-hidden`}
  whileHover={{ rotate: 10, scale: 1.1 }}
  transition={{ type: "spring", stiffness: 300 }}
>
  <img 
    src={service.image} 
    alt="" 
    className="w-full h-full object-cover rounded-full"
  />
</motion.div>

                  {service.title}
                </motion.h3>
                <motion.p 
  className="text-gray-600 mb-4"
  initial={{ opacity: 0 }}
  animate={{ opacity: 1 }}
  transition={{ duration: 0.5, delay: 0.3 }}
>
  {service.description.split(' ').slice(0, 15).join(' ')}...
</motion.p>

                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.4 }}
                    >
                  <Link 
                    to={`/${activeTab}-services/${service.id}`}
                    className={`inline-flex items-center text-${service.color}-600 font-medium hover:text-${service.color}-800 transition-colors group`}
                  >
                    Learn more
                    <motion.svg 
                      className="w-5 h-5 ml-1" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                      initial={{ x: 0 }}
                      whileHover={{ x: 3 }}
                      transition={{ type: "spring", stiffness: 400 }}
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </motion.svg>
                  </Link>
                </motion.div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
      
      {/* Wave separator with animation */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden">
        <motion.svg 
          className="relative block w-full h-12 md:h-16"
          viewBox="0 0 1200 120" 
          preserveAspectRatio="none"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.8 }}
        >
          <motion.path 
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C59.71,118.11,141.89,111.41,213.34,91.94Z" 
            className="fill-white"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 2, ease: "easeInOut" }}
          ></motion.path>
        </motion.svg>
      </div>
      
      {/* CSS for animations */}
      <style jsx>{`
        .shape-circle {
          position: absolute;
          width: 300px;
          height: 300px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(59, 130, 246, 0.1) 0%, rgba(59, 130, 246, 0) 70%);
          top: 10%;
          right: 5%;
        }
        
        .shape-square {
          position: absolute;
          width: 200px;
          height: 200px;
          background: radial-gradient(circle, rgba(20, 184, 166, 0.1) 0%, rgba(20, 184, 166, 0) 70%);
          bottom: 10%;
          left: 5%;
          transform: rotate(45deg);
        }
        
        .shape-triangle {
          position: absolute;
          width: 0;
          height: 0;
          border-left: 150px solid transparent;
          border-right: 150px solid transparent;
          border-bottom: 260px solid rgba(99, 102, 241, 0.05);
          top: 30%;
          left: 20%;
        }
        
        .particles-container {
          position: absolute;
          width: 100%;
          height: 100%;
        }
        
        .particle {
          position: absolute;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          bottom: 20%;
          left: 50%;
        }

        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.1); }
        }
        
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
          100% { transform: translateY(0px); }
        }
      `}</style>
      <ScrollToTopButton />

    </div>
  );
};

export default ServicesPage;